const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/envelope-types`,
    search: `${API_URL}/envelope-type/search`
};

export default apiUrls;
